<!--suppress JSUnresolvedReference -->
<template>
    <div style="width: 100%;height: 100%; position: relative; ">
        <baidu-map class="map" :center="{lng: lng, lat: lat}" :zoom="zoom">
            <bml-heatmap v-if="mode ===1" :data="data.list" :max="data.max" :radius="30">
            </bml-heatmap>
            <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
            <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
            <bm-marker v-if="mode ===2" :position="{lng: lng, lat: lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
            <bm-driving
                    v-if="mode ===3"
                    :start="start"
                    :end="end"
                    :auto-viewport="true"
            ></bm-driving>
        </baidu-map>
    </div>
</template>

<script>
import {BmlHeatmap} from 'vue-baidu-map'
import {BmNavigation} from 'vue-baidu-map'
import {BmMapType} from 'vue-baidu-map'
import {BmMarker} from 'vue-baidu-map'

export default {
    components: {
        BmlHeatmap,
        BmNavigation,
        BmMapType,
        BmMarker,
    },
    props:{
        lng:Number,
        lat:Number,
        zoom:Number,
        start:String,
        end:String,
        mode:Number
    },
    data() {
        return {
            data: {}
        }
    },
    methods: {
        getHeatMapData() {
            this.$axios({
                method: 'get',
                url: '/getHeatMap',
            }).then(r => {
                this.data = r.data
            })
        }
    },
    mounted() {
        this.getHeatMapData()
    }
}
</script>

<style scoped>
.map {
    height: 100%;
    width: 100%;
}
</style>